function Error404(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Ebene_1"
      version="1.1"
      viewBox="0 0 936.6 562.5"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
      {...props}
    >
      <style type="text/css">
        {`.st0{fill:#353535;}
	.st1{fill:none;}
	.st2{fill:none;stroke:#353535;stroke-width:3;}
`}
      </style>
      <g>
        <g>
          <path
            className="st0"
            d="M334.2,502.8V513h-5.4v-28.9h9.4c1.7,0,3.4,0.2,5,0.7c1.3,0.4,2.5,1,3.5,1.9c0.9,0.8,1.6,1.8,2,2.9
			c0.9,2.4,0.9,5.1,0,7.6c-0.5,1.2-1.2,2.2-2.1,3c-1,0.9-2.2,1.6-3.5,2c-1.6,0.5-3.3,0.7-4.9,0.7L334.2,502.8z M334.2,498.6h4
			c0.9,0,1.7-0.1,2.6-0.4c0.7-0.2,1.3-0.6,1.8-1.1c0.5-0.5,0.9-1,1.1-1.7c0.2-0.7,0.4-1.5,0.4-2.2c0-0.7-0.1-1.4-0.4-2.1
			c-0.2-0.6-0.6-1.2-1.1-1.6c-0.5-0.5-1.1-0.8-1.8-1c-0.8-0.2-1.7-0.4-2.6-0.3h-4V498.6z"
          />
          <path
            className="st0"
            d="M370.4,513h-2.2c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.2-0.5-0.5-0.6-0.8l-0.4-1.5c-0.5,0.4-1,0.8-1.5,1.2
			c-0.5,0.3-1,0.6-1.6,0.9c-0.5,0.2-1.1,0.4-1.7,0.5c-0.7,0.1-1.3,0.2-2,0.2c-0.8,0-1.6-0.1-2.4-0.4c-0.7-0.2-1.3-0.6-1.9-1.1
			c-0.5-0.5-1-1.1-1.2-1.7c-0.3-0.8-0.5-1.6-0.4-2.4c0-0.8,0.2-1.6,0.6-2.3c0.5-0.8,1.2-1.5,2-2c1.2-0.7,2.4-1.2,3.8-1.5
			c1.9-0.4,3.9-0.6,5.9-0.6v-1.2c0.1-1.1-0.2-2.2-0.9-3.1c-0.7-0.7-1.6-1.1-2.5-1c-0.7,0-1.4,0.1-2,0.3c-0.5,0.2-0.9,0.4-1.4,0.6
			c-0.4,0.2-0.8,0.4-1.1,0.6c-0.3,0.2-0.7,0.3-1.1,0.3c-0.3,0-0.6-0.1-0.9-0.3c-0.2-0.2-0.4-0.4-0.6-0.6l-0.9-1.6
			c2.3-2.1,5.4-3.3,8.5-3.2c1.1,0,2.2,0.2,3.2,0.6c0.9,0.4,1.7,0.9,2.4,1.6c0.7,0.7,1.2,1.6,1.5,2.5c0.3,1,0.5,2.1,0.5,3.2
			L370.4,513z M360.8,509.9c0.5,0,0.9,0,1.4-0.1c0.4-0.1,0.8-0.2,1.2-0.4c0.4-0.2,0.8-0.4,1.1-0.7c0.4-0.3,0.7-0.6,1.1-1v-3.4
			c-1.2,0-2.4,0.1-3.6,0.3c-0.8,0.1-1.6,0.4-2.3,0.7c-0.5,0.2-0.9,0.6-1.3,1c-0.2,0.4-0.4,0.8-0.4,1.2c-0.1,0.7,0.2,1.4,0.8,1.9
			C359.4,509.8,360.1,510,360.8,509.9L360.8,509.9z"
          />
          <path
            className="st0"
            d="M384.4,492.1c0.8,0,1.7,0.1,2.5,0.3c0.7,0.2,1.5,0.4,2.1,0.8h5.9v1.8c0,0.3-0.1,0.5-0.2,0.7
			c-0.2,0.2-0.5,0.3-0.8,0.4l-1.8,0.3c0.1,0.4,0.2,0.7,0.3,1.1c0.1,0.4,0.1,0.8,0.1,1.2c0,1.9-0.8,3.7-2.3,4.8
			c-0.8,0.6-1.6,1-2.5,1.3c-1,0.3-2.1,0.5-3.2,0.5c-0.8,0-1.5-0.1-2.3-0.2c-0.6,0.4-1,0.8-1,1.3c0,0.4,0.2,0.8,0.6,0.9
			c0.5,0.2,1,0.4,1.5,0.4c0.7,0.1,1.4,0.1,2.1,0.1c0.8,0,1.6,0,2.4,0.1c0.8,0.1,1.6,0.2,2.4,0.4c0.7,0.2,1.5,0.4,2.1,0.8
			c0.6,0.4,1.1,0.9,1.5,1.5c0.4,0.7,0.6,1.6,0.6,2.4c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.9-1.1,1.7-1.9,2.3c-0.9,0.7-2,1.3-3.1,1.6
			c-1.4,0.4-2.8,0.6-4.2,0.6c-1.4,0-2.7-0.1-4.1-0.5c-1-0.2-2-0.6-2.9-1.2c-0.7-0.4-1.3-1-1.7-1.7c-0.4-0.6-0.6-1.3-0.6-2
			c0-0.9,0.3-1.8,0.9-2.4c0.7-0.7,1.5-1.2,2.4-1.6c-0.5-0.3-0.9-0.7-1.2-1.1c-0.3-0.5-0.5-1.2-0.5-1.8c0-0.3,0.1-0.6,0.2-1
			c0.1-0.3,0.3-0.7,0.5-1c0.2-0.3,0.5-0.6,0.8-0.9c0.4-0.3,0.8-0.6,1.2-0.8c-1-0.5-1.8-1.3-2.4-2.2c-0.6-1-0.9-2.1-0.9-3.3
			c0-1.9,0.8-3.7,2.3-4.8c0.8-0.6,1.6-1.1,2.6-1.3C382.2,492.3,383.3,492.1,384.4,492.1z M389.8,513.9c0-0.4-0.1-0.7-0.4-1
			c-0.3-0.3-0.6-0.5-1-0.6c-0.5-0.2-1-0.3-1.4-0.3c-0.6-0.1-1.2-0.1-1.8-0.1h-1.9c-0.6,0-1.3-0.1-1.9-0.2c-0.5,0.3-1,0.6-1.3,1.1
			c-0.3,0.4-0.5,0.9-0.5,1.5c0,0.4,0.1,0.7,0.3,1c0.2,0.3,0.5,0.6,0.9,0.8c0.5,0.3,1,0.4,1.5,0.5c0.8,0.1,1.5,0.2,2.3,0.2
			c0.8,0,1.6-0.1,2.4-0.2c0.6-0.1,1.1-0.3,1.7-0.6c0.4-0.2,0.7-0.5,0.9-0.9C389.7,514.7,389.8,514.3,389.8,513.9z M384.4,502.2
			c0.5,0,1.1-0.1,1.6-0.3c0.4-0.1,0.8-0.4,1.1-0.7c0.3-0.3,0.5-0.7,0.7-1.1c0.2-0.4,0.2-0.9,0.2-1.4c0-0.9-0.3-1.8-0.9-2.4
			c-1.6-1.2-3.8-1.2-5.5,0c-0.6,0.6-1,1.5-0.9,2.4c0,0.5,0.1,0.9,0.2,1.3c0.1,0.4,0.4,0.8,0.7,1.1c0.3,0.3,0.7,0.6,1.1,0.7
			C383.3,502.2,383.8,502.2,384.4,502.2z"
          />
          <path
            className="st0"
            d="M408.4,492.2c1.2,0,2.4,0.2,3.6,0.6c1.1,0.4,2,1,2.8,1.8c0.8,0.8,1.4,1.8,1.8,2.9c0.5,1.3,0.7,2.6,0.7,4
			c0,0.3,0,0.6,0,0.9c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.4,0.1-0.6,0.1h-12.7c0,1.7,0.6,3.3,1.7,4.6
			c1,1,2.5,1.5,3.9,1.5c0.7,0,1.4-0.1,2.1-0.3c0.5-0.2,1-0.4,1.5-0.6c0.4-0.2,0.8-0.4,1.1-0.6c0.3-0.2,0.6-0.3,1-0.3
			c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3l1.4,1.8c-0.5,0.6-1.1,1.2-1.8,1.6c-0.7,0.4-1.4,0.8-2.1,1c-0.7,0.3-1.5,0.4-2.3,0.5
			c-0.7,0.1-1.5,0.2-2.2,0.2c-1.4,0-2.7-0.2-4-0.7c-1.2-0.5-2.3-1.2-3.2-2.1c-0.9-1-1.7-2.2-2.1-3.4c-0.5-1.5-0.8-3.1-0.8-4.8
			c0-1.3,0.2-2.7,0.7-4c0.4-1.2,1.1-2.3,2-3.2c0.9-0.9,1.9-1.7,3.1-2.2C405.6,492.4,407,492.1,408.4,492.2z M408.5,495.7
			c-1.2-0.1-2.5,0.4-3.4,1.2c-0.9,1-1.4,2.2-1.6,3.5h9.3c0-0.6-0.1-1.2-0.3-1.8c-0.2-0.5-0.4-1.1-0.8-1.5c-0.4-0.4-0.8-0.8-1.4-1
			C409.9,495.8,409.2,495.7,408.5,495.7L408.5,495.7z"
          />
          <path
            className="st0"
            d="M433.1,513v-20.5h3c0.6,0,1.1,0.3,1.3,0.9l0.3,1.6c0.4-0.4,0.8-0.8,1.3-1.2c0.5-0.3,0.9-0.6,1.5-0.9
			c0.5-0.3,1.1-0.5,1.7-0.6c0.6-0.1,1.3-0.2,1.9-0.2c1,0,2,0.2,3,0.6c0.8,0.4,1.6,0.9,2.2,1.6c0.6,0.7,1,1.6,1.3,2.5
			c0.3,1,0.5,2.1,0.5,3.2V513H446v-13.1c0.1-1-0.2-2.1-0.9-2.9c-0.7-0.7-1.6-1.1-2.6-1c-0.8,0-1.7,0.2-2.4,0.6
			c-0.8,0.4-1.5,0.9-2.1,1.6V513H433.1z"
          />
          <path
            className="st0"
            d="M466.6,492.2c1.4,0,2.8,0.2,4.2,0.7c1.2,0.5,2.3,1.2,3.2,2.1c0.9,1,1.6,2.1,2,3.3c1,2.8,1,5.9,0,8.8
			c-0.4,1.2-1.1,2.4-2,3.3c-0.9,0.9-2,1.7-3.2,2.1c-2.7,1-5.7,1-8.3,0c-1.2-0.5-2.3-1.2-3.2-2.1c-0.9-1-1.6-2.1-2.1-3.3
			c-1-2.8-1-5.9,0-8.8c0.4-1.2,1.1-2.4,2.1-3.3c0.9-0.9,2-1.6,3.2-2.1C463.7,492.4,465.1,492.1,466.6,492.2z M466.6,509.5
			c1.5,0.1,2.9-0.5,3.8-1.7c0.9-1.5,1.3-3.3,1.2-5c0.1-1.8-0.3-3.5-1.2-5.1c-0.9-1.2-2.3-1.8-3.8-1.7c-1.5-0.1-2.9,0.5-3.8,1.8
			c-0.9,1.5-1.4,3.3-1.2,5c-0.1,1.8,0.3,3.5,1.2,5C463.6,509,465.1,509.6,466.6,509.5z"
          />
          <path
            className="st0"
            d="M489.3,513.3c-1.5,0.1-3-0.5-4.1-1.5c-1-1.1-1.5-2.6-1.4-4.2v-11.5h-2.1c-0.5,0-1-0.4-1-0.9c0,0,0-0.1,0-0.1
			v-2l3.3-0.5l1-5.6c0-0.2,0.2-0.5,0.4-0.6c0.2-0.2,0.5-0.2,0.7-0.2h2.6v6.5h5.4v3.5h-5.4v11.1c0,0.5,0.1,1.1,0.5,1.5
			c0.3,0.4,0.8,0.6,1.3,0.5c0.3,0,0.5,0,0.8-0.1c0.2-0.1,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.2-0.1,0.4-0.1
			c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.3,0.3l1.5,2.4c-0.7,0.6-1.6,1.1-2.5,1.4C491.2,513.2,490.3,513.3,489.3,513.3z"
          />
          <path
            className="st0"
            d="M510.6,513v-16.8l-1.8-0.3c-0.3,0-0.7-0.2-0.9-0.4c-0.2-0.2-0.4-0.5-0.4-0.8v-2h3.1v-1.5
			c0-1.1,0.2-2.1,0.5-3.2c0.7-1.8,2.1-3.2,3.9-3.9c1-0.4,2.1-0.5,3.2-0.5c0.9,0,1.8,0.1,2.6,0.4l-0.1,2.5c0,0.3-0.2,0.6-0.5,0.7
			c-0.4,0.1-0.8,0.1-1.2,0.1c-0.5,0-1.1,0.1-1.6,0.2c-0.4,0.1-0.8,0.3-1.2,0.7c-0.3,0.3-0.6,0.8-0.7,1.2c-0.2,0.6-0.3,1.3-0.3,1.9
			v1.4h5.3v3.5h-5.2V513H510.6z"
          />
          <path
            className="st0"
            d="M534.5,492.2c1.4,0,2.8,0.2,4.2,0.7c1.2,0.5,2.3,1.2,3.2,2.1c0.9,0.9,1.6,2.1,2,3.3c1,2.8,1,5.9,0,8.8
			c-0.4,1.2-1.1,2.4-2,3.3c-0.9,0.9-2,1.7-3.2,2.1c-2.7,1-5.7,1-8.3,0c-1.2-0.5-2.3-1.2-3.2-2.1c-0.9-1-1.6-2.1-2.1-3.3
			c-1-2.8-1-5.9,0-8.8c0.4-1.2,1.1-2.4,2.1-3.3c0.9-0.9,2-1.6,3.2-2.1C531.7,492.4,533.1,492.1,534.5,492.2z M534.5,509.5
			c1.5,0.1,2.9-0.5,3.8-1.7c0.9-1.5,1.3-3.3,1.2-5c0.1-1.8-0.3-3.5-1.2-5.1c-0.9-1.2-2.3-1.8-3.8-1.7c-1.5-0.1-2.9,0.5-3.8,1.8
			c-0.9,1.5-1.4,3.3-1.2,5c-0.1,1.8,0.3,3.5,1.2,5C531.6,509,533,509.6,534.5,509.5z"
          />
          <path
            className="st0"
            d="M555,492.5v13c-0.1,1,0.2,2.1,0.9,2.9c0.7,0.7,1.6,1.1,2.6,1c0.8,0,1.7-0.2,2.4-0.6c0.8-0.4,1.5-0.9,2.1-1.6
			v-14.8h4.9V513h-3c-0.6,0-1.1-0.3-1.3-0.9l-0.3-1.6c-0.4,0.4-0.9,0.8-1.3,1.2c-0.4,0.4-0.9,0.7-1.5,0.9c-0.5,0.3-1.1,0.4-1.7,0.6
			c-0.6,0.1-1.3,0.2-1.9,0.2c-1,0-2-0.2-3-0.6c-0.8-0.4-1.6-0.9-2.2-1.6c-0.6-0.7-1.1-1.6-1.3-2.5c-0.3-1-0.5-2.1-0.4-3.2v-13H555z"
          />
          <path
            className="st0"
            d="M575.2,513v-20.5h3c0.6,0,1.1,0.3,1.3,0.9l0.3,1.6c0.4-0.4,0.8-0.8,1.3-1.2c0.5-0.3,0.9-0.6,1.5-0.9
			c0.5-0.3,1.1-0.5,1.7-0.6c0.6-0.1,1.3-0.2,1.9-0.2c1,0,2,0.2,3,0.6c0.8,0.4,1.6,0.9,2.2,1.6c0.6,0.7,1,1.6,1.3,2.5
			c0.3,1,0.5,2.1,0.5,3.2V513h-4.9v-13.1c0.1-1-0.2-2.1-0.9-2.9c-0.7-0.7-1.6-1.1-2.6-1c-0.8,0-1.7,0.2-2.4,0.6
			c-0.8,0.4-1.5,0.9-2.1,1.6V513H575.2z"
          />
          <path
            className="st0"
            d="M614.4,513c-0.6,0-1.1-0.3-1.3-0.9l-0.4-2c-0.4,0.5-0.9,0.9-1.3,1.3c-0.5,0.4-1,0.7-1.5,1
			c-0.6,0.3-1.1,0.5-1.7,0.7c-0.7,0.2-1.3,0.2-2,0.2c-2.2,0-4.2-1-5.5-2.7c-0.7-1-1.3-2.1-1.6-3.3c-0.4-1.5-0.6-3-0.5-4.5
			c0-1.4,0.2-2.9,0.6-4.2c0.4-1.2,1-2.4,1.8-3.4c0.8-0.9,1.7-1.7,2.8-2.3c1.1-0.6,2.4-0.8,3.6-0.8c1,0,2,0.2,2.9,0.6
			c0.8,0.4,1.5,0.9,2.2,1.5v-10.8h4.9V513H614.4z M607.8,509.4c0.9,0,1.8-0.2,2.6-0.6c0.8-0.5,1.5-1.1,2-1.8v-9.2
			c-0.5-0.6-1.1-1.1-1.8-1.4c-0.7-0.3-1.4-0.4-2.1-0.4c-0.7,0-1.4,0.1-2,0.4c-0.6,0.3-1.1,0.7-1.5,1.3c-0.5,0.7-0.8,1.4-1,2.2
			c-0.2,1-0.4,2-0.3,3.1c0,1,0.1,2,0.3,3c0.1,0.7,0.4,1.4,0.8,2c0.3,0.5,0.8,0.9,1.3,1.1C606.6,509.3,607.2,509.4,607.8,509.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            className="st0"
            d="M349.5,555.9h8.1v2.1h-10.6v-18.6h2.5V555.9z"
          />
          <path
            className="st0"
            d="M366.1,544.6c0.9,0,1.8,0.2,2.6,0.5c0.8,0.3,1.4,0.8,2,1.4c0.6,0.6,1,1.3,1.2,2.1c0.6,1.8,0.6,3.8,0,5.6
			c-0.3,0.8-0.7,1.5-1.2,2.1c-0.5,0.6-1.2,1.1-2,1.4c-1.7,0.6-3.5,0.6-5.2,0c-0.8-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.3-1.3-2.1
			c-0.6-1.8-0.6-3.8,0-5.6c0.3-0.8,0.7-1.5,1.3-2.1c0.6-0.6,1.2-1.1,2-1.4C364.3,544.8,365.2,544.6,366.1,544.6z M366.1,556.4
			c1.1,0.1,2.2-0.4,2.9-1.3c1.3-2.3,1.3-5,0-7.3c-0.7-0.9-1.8-1.4-2.9-1.3c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.6-1.2,1
			c-0.3,0.5-0.6,1-0.7,1.6c-0.2,0.7-0.2,1.4-0.2,2.1c0,0.7,0.1,1.4,0.2,2.1c0.1,0.6,0.4,1.1,0.7,1.6c0.3,0.4,0.7,0.7,1.2,1
			C364.9,556.3,365.5,556.4,366.1,556.4L366.1,556.4z"
          />
          <path
            className="st0"
            d="M381.9,544.6c0.9,0,1.8,0.2,2.6,0.5c0.8,0.3,1.4,0.8,2,1.4c0.6,0.6,1,1.3,1.2,2.1c0.6,1.8,0.6,3.8,0,5.6
			c-0.3,0.8-0.7,1.5-1.2,2.1c-0.5,0.6-1.2,1.1-2,1.4c-1.7,0.6-3.5,0.6-5.2,0c-0.8-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.3-1.3-2.1
			c-0.6-1.8-0.6-3.8,0-5.6c0.3-0.8,0.7-1.5,1.3-2.1c0.6-0.6,1.2-1.1,2-1.4C380.1,544.8,381,544.6,381.9,544.6z M381.9,556.4
			c1.1,0.1,2.2-0.4,2.9-1.3c1.3-2.3,1.3-5,0-7.3c-0.7-0.9-1.8-1.4-2.9-1.3c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.6-1.2,1
			c-0.3,0.5-0.6,1-0.7,1.6c-0.2,0.7-0.2,1.4-0.2,2.1c0,0.7,0.1,1.4,0.2,2.1c0.1,0.6,0.4,1.1,0.7,1.6c0.3,0.4,0.7,0.7,1.2,1
			C380.7,556.3,381.3,556.4,381.9,556.4L381.9,556.4z"
          />
          <path
            className="st0"
            d="M394.7,538.9v11.3h0.6c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.2,0.4-0.3l4.2-4.5c0.1-0.1,0.2-0.2,0.4-0.3
			c0.2-0.1,0.3-0.1,0.5-0.1h2.1l-4.8,5.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.3,0.2-0.4,0.3c0.2,0.1,0.3,0.2,0.4,0.4
			c0.1,0.1,0.3,0.3,0.4,0.5l5.1,6.5h-2.1c-0.2,0-0.3,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3l-4.3-5.4c-0.1-0.2-0.2-0.3-0.4-0.4
			c-0.2-0.1-0.4-0.1-0.6-0.1h-0.6v6.3h-2.3v-19.1H394.7z"
          />
          <path
            className="st0"
            d="M414.7,547c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.4-0.2-0.6-0.3
			c-0.3-0.1-0.6-0.2-0.9-0.3c-0.4-0.1-0.8-0.2-1.2-0.2c-0.4,0-0.7,0-1.1,0.2c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.4,0.4-0.5,0.6
			c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6c0.4,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.3,1.3,0.4
			c0.4,0.1,0.8,0.3,1.3,0.5c0.4,0.2,0.8,0.4,1.1,0.7c0.3,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.9,0.3,1.4c0,0.6-0.1,1.1-0.3,1.7
			c-0.2,0.5-0.5,1-1,1.3c-0.5,0.4-1,0.7-1.6,0.9c-0.7,0.2-1.4,0.3-2.1,0.3c-0.9,0-1.7-0.1-2.5-0.4c-0.7-0.3-1.3-0.7-1.9-1.2l0.5-0.9
			c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.3,0.2,0.6,0.3,0.9,0.4
			c0.4,0.1,0.9,0.2,1.3,0.2c0.4,0,0.8-0.1,1.2-0.2c0.3-0.1,0.6-0.3,0.8-0.5c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.2-0.5,0.2-0.8
			c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.3-0.5-0.5-0.8-0.6c-0.4-0.2-0.7-0.3-1.1-0.4c-0.4-0.1-0.8-0.3-1.3-0.4c-0.4-0.1-0.8-0.3-1.3-0.5
			c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.6-0.6-0.8-1c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.5-0.9,0.9-1.2
			c0.4-0.4,0.9-0.7,1.5-0.8c0.6-0.2,1.3-0.3,2-0.3c0.8,0,1.6,0.1,2.3,0.4c0.7,0.3,1.3,0.6,1.8,1.1L414.7,547z"
          />
          <path className="st0" d="M428.7,538.9V558h-2.3v-19.1H428.7z" />
          <path
            className="st0"
            d="M437.2,540.7c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.4-0.4,0.5c-0.2,0.2-0.3,0.3-0.5,0.4
			c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.6-0.1c-0.4-0.2-0.7-0.5-0.9-0.9c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0.1-0.6
			c0.1-0.2,0.2-0.4,0.4-0.5c0.1-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.4,0.2,0.5,0.4
			c0.2,0.2,0.3,0.3,0.4,0.5C437.1,540.3,437.2,540.5,437.2,540.7z M436.6,544.8V558h-2.3v-13.2H436.6z"
          />
          <path
            className="st0"
            d="M444.4,538.9v11.3h0.6c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.2,0.4-0.3l4.2-4.5c0.1-0.1,0.2-0.2,0.4-0.3
			c0.2-0.1,0.3-0.1,0.5-0.1h2.1l-4.8,5.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.3,0.2-0.4,0.3c0.2,0.1,0.3,0.2,0.4,0.4
			c0.1,0.1,0.3,0.3,0.4,0.5l5.1,6.5h-2.1c-0.2,0-0.3,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3l-4.3-5.4c-0.1-0.2-0.2-0.3-0.4-0.4
			c-0.2-0.1-0.4-0.1-0.6-0.1h-0.6v6.3h-2.3v-19.1H444.4z"
          />
          <path
            className="st0"
            d="M461.4,544.6c0.7,0,1.5,0.1,2.2,0.4c0.7,0.3,1.2,0.6,1.7,1.1c0.5,0.5,0.9,1.2,1.1,1.8
			c0.3,0.8,0.4,1.7,0.4,2.5c0,0.2,0,0.5-0.1,0.7c-0.1,0.1-0.3,0.2-0.4,0.2h-8.8c0,0.7,0.1,1.5,0.3,2.2c0.2,0.6,0.5,1.1,0.9,1.5
			c0.4,0.4,0.8,0.7,1.3,0.9c0.5,0.2,1.1,0.3,1.7,0.3c0.5,0,1-0.1,1.5-0.2c0.4-0.1,0.7-0.3,1.1-0.4c0.3-0.1,0.5-0.3,0.8-0.4
			c0.2-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.4,0.2l0.6,0.8c-0.3,0.4-0.6,0.7-1,0.9c-0.4,0.3-0.8,0.5-1.3,0.6
			c-0.5,0.2-0.9,0.3-1.4,0.4c-0.5,0.1-1,0.1-1.4,0.1c-0.9,0-1.7-0.1-2.5-0.5c-0.8-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.4-1.3-2.2
			c-0.3-1-0.5-2-0.5-3c0-0.9,0.1-1.7,0.4-2.6c0.3-0.8,0.7-1.5,1.2-2.1c0.5-0.6,1.2-1.1,1.9-1.4C459.6,544.8,460.5,544.6,461.4,544.6
			z M461.4,546.3c-1-0.1-1.9,0.3-2.6,1c-0.7,0.7-1.1,1.7-1.2,2.7h7.2c0-0.5-0.1-1-0.2-1.5c-0.1-0.4-0.4-0.8-0.6-1.2
			c-0.3-0.3-0.6-0.6-1-0.8C462.4,546.4,461.9,546.3,461.4,546.3z"
          />
          <path
            className="st0"
            d="M481.3,561.9c-0.1,0.2-0.2,0.3-0.3,0.4c-0.2,0.1-0.3,0.2-0.5,0.2h-1.7l2.4-5.2l-5.4-12.4h2
			c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.2,0.2,0.2,0.3l3.5,8.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.1,0.4,0.1,0.6c0.1-0.2,0.1-0.4,0.2-0.6
			c0.1-0.2,0.1-0.4,0.2-0.6l3.4-8.3c0.1-0.1,0.1-0.3,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1h1.8L481.3,561.9z"
          />
          <path
            className="st0"
            d="M497,544.6c0.9,0,1.8,0.2,2.6,0.5c0.8,0.3,1.4,0.8,2,1.4c0.6,0.6,1,1.3,1.2,2.1c0.6,1.8,0.6,3.8,0,5.6
			c-0.3,0.8-0.7,1.5-1.2,2.1c-0.5,0.6-1.2,1.1-2,1.4c-1.7,0.6-3.5,0.6-5.2,0c-0.8-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.3-1.3-2.1
			c-0.6-1.8-0.6-3.8,0-5.6c0.3-0.8,0.7-1.5,1.3-2.1c0.6-0.6,1.2-1.1,2-1.4C495.2,544.8,496.1,544.6,497,544.6z M497,556.4
			c1.1,0.1,2.2-0.4,2.9-1.3c1.3-2.3,1.3-5,0-7.3c-0.7-0.9-1.8-1.4-2.9-1.3c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.6-1.2,1
			c-0.3,0.5-0.6,1-0.7,1.6c-0.2,0.7-0.2,1.4-0.2,2.1c0,0.7,0.1,1.4,0.2,2.1c0.1,0.6,0.4,1.1,0.7,1.6c0.3,0.4,0.7,0.7,1.2,1
			C495.8,556.3,496.4,556.4,497,556.4L497,556.4z"
          />
          <path
            className="st0"
            d="M509.4,544.8v8.4c-0.1,0.8,0.2,1.6,0.7,2.3c0.5,0.6,1.3,0.9,2.1,0.8c0.7,0,1.3-0.2,1.9-0.5
			c0.6-0.3,1.2-0.8,1.7-1.3v-9.7h2.3V558h-1.4c-0.3,0-0.6-0.2-0.6-0.5l-0.2-1.4c-0.5,0.6-1.2,1.1-1.9,1.5c-0.8,0.4-1.6,0.6-2.4,0.6
			c-0.7,0-1.3-0.1-1.9-0.4c-0.5-0.2-1-0.6-1.4-1c-0.4-0.5-0.7-1-0.8-1.6c-0.2-0.7-0.3-1.4-0.3-2v-8.4H509.4z"
          />
          <path
            className="st0"
            d="M525.3,539.4v3.8l-0.2,2c0,0.2-0.1,0.5-0.2,0.6c-0.1,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.5-0.2
			c-0.1-0.2-0.2-0.4-0.3-0.6l-0.2-2v-3.8H525.3z"
          />
          <path
            className="st0"
            d="M530.5,558v-13.2h1.3c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.2,0.3,0.2,0.5l0.2,2.1c0.4-0.8,1-1.6,1.7-2.2
			c1-0.7,2.2-0.9,3.3-0.6c0.3,0.1,0.6,0.2,0.8,0.3l-0.3,1.7c0,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.3-0.1-0.7-0.1-1.1-0.1
			c-0.7,0-1.5,0.2-2,0.7c-0.6,0.6-1.1,1.3-1.4,2v8.4L530.5,558z"
          />
          <path
            className="st0"
            d="M547.5,544.6c0.7,0,1.5,0.1,2.2,0.4c0.7,0.3,1.2,0.6,1.7,1.1c0.5,0.5,0.9,1.2,1.1,1.8
			c0.3,0.8,0.4,1.7,0.4,2.5c0,0.2,0,0.5-0.1,0.7c-0.1,0.1-0.3,0.2-0.4,0.2h-8.8c0,0.7,0.1,1.5,0.3,2.2c0.2,0.6,0.5,1.1,0.9,1.5
			c0.4,0.4,0.8,0.7,1.3,0.9c0.5,0.2,1.1,0.3,1.7,0.3c0.5,0,1-0.1,1.5-0.2c0.4-0.1,0.7-0.3,1.1-0.4c0.3-0.1,0.5-0.3,0.8-0.4
			c0.2-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.4,0.2l0.6,0.8c-0.3,0.4-0.6,0.7-1,0.9c-0.4,0.3-0.8,0.5-1.3,0.6
			c-0.5,0.2-0.9,0.3-1.4,0.4c-0.5,0.1-1,0.1-1.4,0.1c-0.9,0-1.7-0.1-2.5-0.5c-0.8-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.4-1.3-2.2
			c-0.3-1-0.5-2-0.5-3c0-0.9,0.1-1.7,0.4-2.6c0.3-0.8,0.7-1.5,1.2-2.1c0.5-0.6,1.2-1.1,1.9-1.4C545.7,544.8,546.6,544.6,547.5,544.6
			z M547.5,546.3c-1-0.1-1.9,0.3-2.6,1c-0.7,0.7-1.1,1.7-1.2,2.7h7.2c0-0.5-0.1-1-0.2-1.5c-0.1-0.4-0.4-0.8-0.6-1.2
			c-0.3-0.3-0.6-0.6-1-0.8C548.5,546.4,548,546.3,547.5,546.3z"
          />
          <path className="st0" d="M566.1,538.9V558h-2.3v-19.1H566.1z" />
          <path
            className="st0"
            d="M576.8,544.6c0.9,0,1.8,0.2,2.6,0.5c0.8,0.3,1.4,0.8,2,1.4c0.6,0.6,1,1.3,1.2,2.1c0.6,1.8,0.6,3.8,0,5.6
			c-0.3,0.8-0.7,1.5-1.2,2.1c-0.5,0.6-1.2,1.1-2,1.4c-1.7,0.6-3.5,0.6-5.2,0c-0.8-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.3-1.3-2.1
			c-0.6-1.8-0.6-3.8,0-5.6c0.3-0.8,0.7-1.5,1.3-2.1c0.6-0.6,1.2-1.1,2-1.4C575,544.8,575.9,544.6,576.8,544.6z M576.8,556.4
			c1.1,0.1,2.2-0.4,2.9-1.3c1.3-2.3,1.3-5,0-7.3c-0.7-0.9-1.8-1.4-2.9-1.3c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.6-1.2,1
			c-0.3,0.5-0.6,1-0.7,1.6c-0.2,0.7-0.2,1.4-0.2,2.1c0,0.7,0.1,1.4,0.2,2.1c0.1,0.6,0.4,1.1,0.7,1.6c0.3,0.4,0.7,0.7,1.2,1
			C575.6,556.3,576.2,556.4,576.8,556.4L576.8,556.4z"
          />
          <path
            className="st0"
            d="M594.7,547c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.4-0.2-0.6-0.3
			c-0.3-0.1-0.6-0.2-0.9-0.3c-0.4-0.1-0.8-0.2-1.2-0.2c-0.4,0-0.7,0-1.1,0.2c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.4,0.4-0.5,0.6
			c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.8,0.6c0.4,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.3,1.3,0.4
			c0.4,0.1,0.8,0.3,1.3,0.5c0.4,0.2,0.8,0.4,1.1,0.7c0.3,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.9,0.3,1.4c0,0.6-0.1,1.1-0.3,1.7
			c-0.2,0.5-0.5,1-1,1.3c-0.5,0.4-1,0.7-1.6,0.9c-0.7,0.2-1.4,0.3-2.1,0.3c-0.9,0-1.7-0.1-2.5-0.4c-0.7-0.3-1.3-0.7-1.9-1.2l0.5-0.9
			c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.4,0.3,0.6,0.4c0.3,0.2,0.6,0.3,0.9,0.4
			c0.4,0.1,0.9,0.2,1.3,0.2c0.4,0,0.8-0.1,1.2-0.2c0.3-0.1,0.6-0.3,0.8-0.5c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.2-0.5,0.2-0.8
			c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.3-0.5-0.5-0.8-0.6c-0.4-0.2-0.7-0.3-1.1-0.4c-0.4-0.1-0.8-0.3-1.3-0.4c-0.4-0.1-0.9-0.3-1.3-0.5
			c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.6-0.6-0.8-1c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.5-0.9,0.9-1.2
			c0.4-0.4,0.9-0.7,1.5-0.8c0.6-0.2,1.3-0.3,2-0.3c0.8,0,1.6,0.1,2.3,0.4c0.7,0.3,1.3,0.6,1.8,1.1L594.7,547z"
          />
          <path
            className="st0"
            d="M603.8,558.2c-0.9,0.1-1.8-0.3-2.4-0.9c-0.6-0.7-0.9-1.6-0.8-2.5v-8.1H599c-0.1,0-0.3,0-0.4-0.1
			c-0.1-0.1-0.2-0.2-0.1-0.4v-0.9l2.2-0.3l0.5-4.1c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.1h1.2v4.5h3.8v1.7h-3.8v7.9
			c0,0.4,0.1,0.9,0.4,1.2c0.3,0.3,0.7,0.4,1,0.4c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.1,0.3-0.2
			c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.3,0.1,0.3,0.2l0.7,1.1c-0.4,0.4-0.9,0.7-1.4,0.9C605,558.1,604.4,558.2,603.8,558.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            className="st0"
            d="M335,364.3h20.9v16.4c0,1.5-0.5,2.9-1.5,4c-1.1,1.2-2.7,1.8-4.4,1.7H335V427h-24.8v-40.6H240
			c-3.7,0-7-2.6-7.8-6.2l-2.9-14.4l78.8-105.2H335V364.3z M310.2,309.9c0-2.5,0.1-5.1,0.2-7.9c0.2-2.8,0.4-5.8,0.8-8.9l-51.6,71.2
			h50.6L310.2,309.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            className="st0"
            d="M701,364.3h20.9v16.4c0,1.5-0.5,2.9-1.5,4c-1.1,1.2-2.7,1.8-4.4,1.7H701V427h-24.8v-40.6H606
			c-3.7,0-7-2.6-7.8-6.2l-2.9-14.4l78.8-105.2H701V364.3z M676.2,309.9c0-2.5,0.1-5.1,0.2-7.9c0.2-2.8,0.4-5.8,0.8-8.9l-51.6,71.2
			h50.6L676.2,309.9z"
          />
        </g>
      </g>
      <path
        className="st1"
        d="M387.5,360.7c-0.4-1.4-0.7-2.9-1-4.4C386.8,357.8,387.2,359.3,387.5,360.7z"
      />
      <path
        className="st1"
        d="M387.5,315.3c-0.4,1.4-0.7,2.9-1,4.4C386.8,318.2,387.2,316.7,387.5,315.3z"
      />
      <path
        className="st1"
        d="M432.1,417.9c-13-7.1-24.1-17.3-32.3-29.6C408,400.6,419.1,410.8,432.1,417.9z"
      />
      <path
        className="st1"
        d="M432.1,258.1c-13,7.1-24.1,17.3-32.3,29.6C408,275.4,419.1,265.2,432.1,258.1z"
      />
      <path
        className="st1"
        d="M520.9,272.2c-0.2,0-0.4-0.1-0.7-0.2C520.5,272,520.7,272.1,520.9,272.2z"
      />
      <path
        className="st1"
        d="M538.3,370.6c0,0.3,0,0.5,0,0.8c-2.6,4.8-5.7,9.3-9.3,13.4c-3.9-6.4-10.9-13-22.4-8.5
	c-19.9,7.8-32.9,0.3-50.7-5.3c-11.5-3.6-24.7,7.2-32.4,15.3c-11.6-12.5-18.3-28.9-18.9-46c7.5,0.1,7.1-8.6,6.2-15
	c-0.9-6.5,9.6-8.7,11.2-15.2c0.9-3.8-2.1-8.7-5.3-11.6c6.3-9.3,14.6-17,24.4-22.4h0c6,4.2,18.3,9.7,37.2,3.6
	c12-3.9,15-7.5,15.9-10.1c22.7,6.2,40.9,23.2,48.6,45.4c-7,1.1-17,7.3-20.6,5.1c-5.6-3.4-17.7-24.9-29.8-18
	c-12.1,6.8,10.9,10,8.4,18c-2.5,8.1-12.4,0-25.5,5.3c-13,5.3-10.6-3.1-26.4,0s-11.2,33.9-4,33.3c7.1-0.6,7.8-17.1,15.5-14.6
	c7.8,2.5,5.9,12.1,18.3,8.7c12.4-3.4,18.6-11.5,22.1-10.6c3.4,0.9,16.8,12.8,4.7,16.5c-12.1,3.7-15.5,7.5-6.5,8.4
	c7.3,0.8,13.5-6.3,18.1-5.9c1.1,0.2,2,0.9,2.5,1.8c4,6.2,4-0.3,4.4-6.8c0.3-6.5-0.9-14.6,3.4-14S538.7,352.6,538.3,370.6z"
      />
      <path
        className="st1"
        d="M551.5,388.3c-8.2,12.4-19.3,22.5-32.3,29.6C532.2,410.8,543.3,400.6,551.5,388.3z"
      />
      <path
        className="st1"
        d="M551.5,287.7c-8.2-12.3-19.3-22.5-32.3-29.6C532.2,265.2,543.3,275.4,551.5,287.7z"
      />
      <path
        className="st1"
        d="M564.8,356.3c-0.3,1.5-0.6,2.9-1,4.4C564.2,359.3,564.5,357.8,564.8,356.3z"
      />
      <path
        className="st1"
        d="M564.8,319.7c-0.3-1.5-0.7-2.9-1-4.4C564.2,316.7,564.5,318.2,564.8,319.7z"
      />
      <path
        className="st0"
        d="M520.2,272c0.3,0.1,0.5,0.2,0.7,0.2C520.7,272.1,520.5,272,520.2,272z"
      />
      <path
        className="st0"
        d="M564.8,319.7c-0.3-1.5-0.7-2.9-1-4.4v0c-0.4-1.5-0.8-3-1.3-4.5c-0.6-1.8-1.2-3.5-1.8-5.3
	c-0.6-1.5-1.2-3.1-1.9-4.6c-0.2-0.5-0.4-1-0.7-1.5c-0.5-1-0.9-1.9-1.4-2.9c-0.3-0.5-0.5-1-0.8-1.4c0,0,0,0,0,0
	c-0.3-0.5-0.6-1.1-0.9-1.6c-0.6-1-1.2-2.1-1.8-3.1v0c-0.3-0.5-0.6-0.9-0.8-1.3c-0.3-0.4-0.6-0.9-0.8-1.3
	c-8.2-12.3-19.3-22.5-32.3-29.6c-0.9-0.5-1.8-1-2.7-1.4c-0.5-0.3-1.1-0.5-1.6-0.8h0c-1.3-0.6-2.6-1.2-3.9-1.8
	c-1.5-0.6-3.1-1.2-4.6-1.8c-1.3-0.5-2.6-0.9-4-1.3c-2-0.6-4-1.2-6.1-1.6c-13.5-3.1-27.6-3.1-41.1,0c-2.1,0.5-4.1,1-6.1,1.6
	c-1.3,0.4-2.7,0.9-4,1.3c-1.6,0.6-3.1,1.2-4.6,1.8c-1.3,0.6-2.6,1.2-3.9,1.8c-0.5,0.3-1.1,0.5-1.6,0.8c-0.9,0.5-1.8,0.9-2.7,1.4
	c-13,7.1-24.1,17.3-32.3,29.6c-0.3,0.4-0.6,0.9-0.8,1.3c-0.3,0.5-0.6,0.9-0.8,1.3v0c-0.6,1-1.2,2.1-1.8,3.1
	c-0.3,0.5-0.6,1.1-0.9,1.6v0c-0.3,0.5-0.5,1-0.8,1.4c-0.5,1-1,1.9-1.4,2.9c-0.2,0.5-0.5,1-0.7,1.5c-0.7,1.5-1.3,3-1.9,4.6
	c-0.7,1.7-1.3,3.5-1.8,5.3c-0.5,1.5-0.9,3-1.3,4.5v0c-0.4,1.4-0.7,2.9-1,4.4c-2.5,12.1-2.5,24.6,0,36.7c0.3,1.5,0.6,2.9,1,4.4v0
	c0.4,1.5,0.8,3,1.3,4.5c0.6,1.8,1.2,3.5,1.8,5.3c0.6,1.5,1.2,3.1,1.9,4.6c0.2,0.5,0.4,1,0.7,1.5c0.5,1,0.9,1.9,1.4,2.9
	c0.3,0.5,0.5,1,0.8,1.4v0c0.3,0.5,0.6,1.1,0.9,1.6c0.6,1,1.2,2.1,1.8,3.1v0c0.3,0.5,0.6,0.9,0.8,1.3c0.3,0.4,0.6,0.9,0.8,1.3
	c8.2,12.3,19.3,22.5,32.3,29.6c0.9,0.5,1.8,1,2.7,1.4c0.5,0.3,1.1,0.5,1.6,0.8c1.3,0.6,2.6,1.2,3.9,1.8c1.5,0.6,3.1,1.2,4.6,1.8
	c1.3,0.5,2.6,0.9,4,1.3c2,0.6,4,1.2,6.1,1.6c13.5,3.1,27.6,3.1,41.1,0c2.1-0.5,4.1-1,6.1-1.6c1.3-0.4,2.7-0.9,4-1.3
	c1.6-0.6,3.1-1.2,4.6-1.8c0.7-0.3,1.3-0.6,2-0.9c0.7-0.3,1.3-0.6,2-0.9c0.5-0.3,1.1-0.5,1.6-0.8c0.9-0.5,1.8-0.9,2.7-1.4
	c13-7.1,24.1-17.3,32.3-29.6c0.3-0.4,0.6-0.9,0.8-1.3c0.3-0.5,0.6-0.9,0.8-1.3v0c0.6-1,1.2-2.1,1.8-3.1c0.3-0.5,0.6-1.1,0.9-1.6v0
	c0.3-0.5,0.5-1,0.8-1.4c0.5-1,1-1.9,1.4-2.9c0.2-0.5,0.5-1,0.7-1.5c0.7-1.5,1.3-3,1.9-4.6c0.7-1.7,1.3-3.5,1.8-5.3
	c0.5-1.5,0.9-3,1.3-4.5v0c0.4-1.4,0.7-2.9,1-4.4C567.3,344.2,567.3,331.8,564.8,319.7z M520.9,272.2c-0.2,0-0.4-0.1-0.7-0.2
	C520.5,272,520.7,272.1,520.9,272.2L520.9,272.2z M522.2,319.9c-5.6-3.4-17.7-24.9-29.8-18c-12.1,6.8,10.9,10,8.4,18
	c-2.5,8.1-12.4,0-25.5,5.3c-13,5.3-10.6-3.1-26.4,0s-11.2,33.9-4,33.3c7.1-0.6,7.8-17.1,15.5-14.6c7.8,2.5,5.9,12.1,18.3,8.7
	c12.4-3.4,18.6-11.5,22.1-10.6c3.4,0.9,16.8,12.8,4.7,16.5c-12.1,3.7-15.5,7.5-6.5,8.4c7.3,0.8,13.5-6.3,18.1-5.9
	c1.1,0.2,2,0.9,2.5,1.8c4,6.2,4-0.3,4.4-6.8c0.3-6.5-0.9-14.6,3.4-14s11.5,10.6,11.2,28.6c0,0.3,0,0.5,0,0.8
	c-2.6,4.8-5.7,9.3-9.3,13.4c-3.9-6.4-10.9-13-22.4-8.5c-19.9,7.8-32.9,0.3-50.7-5.3c-11.5-3.6-24.7,7.2-32.4,15.3
	c-11.6-12.5-18.3-28.9-18.9-46c7.5,0.1,7.1-8.6,6.2-15c-0.9-6.5,9.6-8.7,11.2-15.2c0.9-3.8-2.1-8.7-5.3-11.6
	c6.3-9.3,14.6-17,24.4-22.4h0c6,4.2,18.3,9.7,37.2,3.6c12-3.9,15-7.5,15.9-10.1c22.7,6.2,40.9,23.2,48.6,45.4
	C535.8,315.9,525.8,322.1,522.2,319.9L522.2,319.9z"
      />
      <path
        className="st0"
        d="M520.9,272.2c-0.2,0-0.4-0.1-0.7-0.2C520.5,272,520.7,272.1,520.9,272.2z"
      />
      <path
        className="st0"
        d="M448.5,299.1c-10.9-9-10.6,5.3-6.8,10.9s7.8,5.3,9.3,3.1S459.4,308.1,448.5,299.1z"
      />
      <path
        className="st0"
        d="M72.6,264.6c-0.1,1.4-0.1,2.8-0.1,4.4v-6.1C70.4,233.2,52.6,234.1,52,234c16.2,0,19.8-21.4,20.5-30.2v-3.5
	c0,0.4,0,1.3,0.1,2.5c0.1-1.7,0.1-2.7,0.1-2.7v4.6c0.8,9.3,4.3,29.4,20.5,29.4c-0.6,0.2-18.4-0.8-20.5,28.9v6.1
	C72.7,267.4,72.7,266,72.6,264.6z M72.5,200v0.2C72.5,200.1,72.5,200,72.5,200z"
      />
      <path
        className="st0"
        d="M880.1,336.8c-0.1,1-0.1,2-0.1,3.1v-4.3c-1.6-21.1-14.6-20.4-15.1-20.5c11.9,0,14.5-15.2,15.1-21.5v-2.5
	c0,0.3,0,0.9,0.1,1.8c0.1-1.2,0.1-1.9,0.1-1.9v3.2c0.6,6.6,3.2,20.9,15.1,20.9c-0.4,0.1-13.5-0.6-15.1,20.5v4.3
	C880.2,338.8,880.2,337.8,880.1,336.8z M880.1,291v0.1V291L880.1,291z"
      />
      <path
        className="st0"
        d="M901.1,354c0,0.6,0,1.2,0,1.9v-2.6c-0.9-12.9-8.8-12.5-9.1-12.5c7.2,0,8.8-9.3,9.1-13.1v-1.5c0,0.2,0,0.5,0,1.1
	c0.1-0.7,0.1-1.2,0.1-1.2v2c0.3,4,1.9,12.8,9.1,12.8c-0.3,0.1-8.1-0.3-9.1,12.5v2.6C901.2,355.3,901.2,354.6,901.1,354z M901.1,326
	L901.1,326C901.1,326,901.1,326,901.1,326L901.1,326z"
      />
      <path
        className="st0"
        d="M13.1,396.2c0,0.9-0.1,1.8-0.1,2.7v-3.8c-1.4-18.5-12.7-17.9-13.1-18c10.3,0,12.6-13.3,13.1-18.8v-2.2
	c0,0.2,0,0.8,0.1,1.5c0.1-1,0.1-1.7,0.1-1.7v2.8c0.5,5.8,2.7,18.3,13.1,18.3c-0.4,0.1-11.7-0.5-13.1,18v3.8
	C13.2,398,13.2,397.1,13.1,396.2z M13.1,356v0.1C13.1,356,13.1,356,13.1,356L13.1,356z"
      />
      <path
        className="st0"
        d="M267.1,28c0,0.6,0,1.2,0,1.9v-2.6c-0.9-12.9-8.8-12.5-9.1-12.5c7.2,0,8.8-9.3,9.1-13.1V0.1c0,0.2,0,0.5,0,1.1
	c0.1-0.7,0.1-1.2,0.1-1.2v2c0.3,4,1.9,12.8,9.1,12.8c-0.3,0.1-8.1-0.3-9.1,12.5v2.6C267.2,29.3,267.2,28.6,267.1,28z M267.1,0
	L267.1,0C267.1,0,267.1,0,267.1,0L267.1,0z"
      />
      <path
        className="st0"
        d="M288.6,53.3c0,0.8-0.1,1.7-0.1,2.6v-3.6c-1.3-17.6-12.2-17-12.6-17.1c10,0,12.1-12.7,12.6-18v-2.1
	c0,0.2,0,0.7,0,1.5c0.1-1,0.1-1.6,0.1-1.6v2.7c0.5,5.5,2.6,17.5,12.6,17.5c-0.4,0.1-11.3-0.5-12.6,17.1v3.6
	C288.7,55,288.7,54.2,288.6,53.3z M288.6,15v0.1C288.6,15,288.6,15,288.6,15L288.6,15z"
      />
      <path
        className="st0"
        d="M856.1,339c0,0.6,0,1.2,0,1.9v-2.6c-0.9-12.9-8.8-12.5-9.1-12.5c7.2,0,8.8-9.3,9.1-13.1v-1.5c0,0.2,0,0.5,0,1.1
	c0.1-0.7,0.1-1.2,0.1-1.2v2c0.3,4,1.9,12.8,9.1,12.8c-0.3,0.1-8.1-0.3-9.1,12.5v2.6C856.2,340.3,856.2,339.6,856.1,339z M856.1,311
	L856.1,311C856.1,311,856.1,311,856.1,311L856.1,311z"
      />
      <path
        className="st0"
        d="M585.6,150.8c0,1-0.1,2-0.1,3.1v-4.3c-1.5-21.1-14.2-20.4-14.6-20.5c11.5,0,14-15.2,14.6-21.5v-2.5
	c0,0.3,0,0.9,0.1,1.8c0.1-1.2,0.1-1.9,0.1-1.9v3.2c0.5,6.6,3,20.9,14.6,20.9c-0.4,0.1-13-0.6-14.6,20.5v4.3
	C585.7,152.8,585.7,151.8,585.6,150.8z M585.6,105v0.1C585.6,105.1,585.6,105,585.6,105z"
      />
      <path
        className="st0"
        d="M543.6,137.3c-0.1,1.5-0.1,3-0.1,4.6v-6.4c-2.2-31.4-20.9-30.4-21.5-30.5c17,0,20.7-22.7,21.5-32v-3.7
	c0,0.4,0,1.3,0.1,2.6c0.1-1.8,0.1-2.8,0.1-2.8v4.8c0.8,9.8,4.5,31.1,21.5,31.1c-0.6,0.2-19.3-0.8-21.5,30.5v6.4
	C543.8,140.3,543.7,138.8,543.6,137.3z M543.5,69v0.2C543.5,69.1,543.5,69,543.5,69z"
      />
      <path
        className="st0"
        d="M102.1,274c0,0.6,0,1.2,0,1.9v-2.6c-0.9-12.9-8.8-12.5-9.1-12.5c7.2,0,8.8-9.3,9.1-13.1v-1.5c0,0.2,0,0.5,0,1.1
	c0.1-0.7,0.1-1.2,0.1-1.2v2c0.3,4,1.9,12.8,9.1,12.8c-0.3,0.1-8.1-0.3-9.1,12.5v2.6C102.2,275.3,102.2,274.6,102.1,274z M102.1,246
	L102.1,246C102.1,246,102.1,246,102.1,246L102.1,246z"
      />
      <path
        className="st0"
        d="M915.7,90c-7.2,0-13,5.8-13,13c0.1,2.9,0.7,5.8,1.8,8.4c1,2.5,2.3,4.8,3.9,7c1.3,1.8,2.7,3.3,4.3,4.8
	c0.8,0.9,1.8,1.5,3,1.8c1.1,0,4.1-2.1,7.1-6.2c1.6-2.2,2.9-4.5,3.9-7c1.2-2.8,1.8-5.8,2-8.9C928.7,95.8,922.9,90,915.7,90z
	 M915.7,107.6c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5S918.5,107.6,915.7,107.6z"
      />
      <g>
        <g>
          <path
            className="st0"
            d="M902.1,148.6v7.4h-2.5v-7.4l-6.8-11.2h2.2c0.2,0,0.4,0,0.5,0.2c0.1,0.1,0.2,0.3,0.3,0.4l4.3,7.2
			c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.2,0.5,0.3,0.8c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.3,0.3-0.6,0.4-0.8l4.3-7.2
			c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.3-0.2,0.5-0.2h2.2L902.1,148.6z"
          />
          <path
            className="st0"
            d="M915.5,142.6c0.9,0,1.8,0.2,2.6,0.5c0.8,0.3,1.4,0.8,2,1.4c0.6,0.6,1,1.3,1.2,2.1c0.6,1.8,0.6,3.8,0,5.6
			c-0.3,0.8-0.7,1.5-1.2,2.1c-0.5,0.6-1.2,1.1-2,1.4c-1.7,0.6-3.5,0.6-5.2,0c-0.8-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.3-1.3-2.1
			c-0.6-1.8-0.6-3.8,0-5.6c0.3-0.8,0.7-1.5,1.3-2.1c0.6-0.6,1.2-1.1,2-1.4C913.7,142.8,914.6,142.6,915.5,142.6z M915.5,154.4
			c1.1,0.1,2.2-0.4,2.9-1.3c1.3-2.3,1.3-5,0-7.3c-0.7-0.9-1.8-1.4-2.9-1.3c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.6-1.2,1
			c-0.3,0.5-0.6,1-0.7,1.6c-0.2,0.7-0.2,1.4-0.2,2.1c0,0.7,0.1,1.4,0.2,2.1c0.1,0.6,0.4,1.1,0.7,1.6c0.3,0.4,0.7,0.7,1.2,1
			C914.3,154.3,914.9,154.4,915.5,154.4L915.5,154.4z"
          />
          <path
            className="st0"
            d="M927.9,142.8v8.4c-0.1,0.8,0.2,1.6,0.7,2.3c0.5,0.6,1.3,0.9,2.1,0.8c0.7,0,1.3-0.2,1.9-0.5
			c0.6-0.3,1.2-0.8,1.7-1.3v-9.7h2.3V156h-1.4c-0.3,0-0.6-0.2-0.6-0.5l-0.2-1.4c-0.5,0.6-1.2,1.1-1.9,1.5c-0.8,0.4-1.6,0.6-2.4,0.6
			c-0.7,0-1.3-0.1-1.9-0.4c-0.5-0.2-1-0.6-1.4-1c-0.4-0.5-0.7-1-0.8-1.6c-0.2-0.7-0.3-1.4-0.3-2v-8.4H927.9z"
          />
        </g>
      </g>
      <path className="st2" d="M773.1,168.6c0,0,29.1-41,89.4-41" />
      <path className="st2" d="M849.1,143.7l14.8-16.5l-16.3-12.9" />
    </svg>
  );
}

export default Error404;
